import React, { useCallback, useContext } from 'react';
import { TouchableOpacity } from 'react-native';
import { AnchoredSheet, AnchoredSheetTitleBar } from '@shared/components/AnchoredSheet';
import { MBView } from '@shared/components/MBView';
import { MBIconV2Name } from '@shared/components/image';
import { AuditTagComponent } from '@shared/scenes/workflows/config';
import { ColorThemeContext, grid } from '@shared/styles';
import { Trigger, useBoolean, useExecuteOnTrigger, useIsDesktop } from '@shared/util/hooks';
import { AuditTag } from './AuditTag';

const FIXED_WIDTH = { width: grid(46) };

interface Props {
  anchorName: string;
  label: string;
  tagOptions: AuditTagComponent['options'];
  isMultiselect: boolean;
  tags: string[];
  children: React.ReactNode;
  trigger: Trigger;
  onChange(selectedTags: string[]): void;
  isReadOnly?: boolean;
}

export function AuditTagModal({
  anchorName,
  tagOptions,
  label,
  isMultiselect,
  tags,
  children,
  trigger,
  onChange,
  isReadOnly,
}: Props) {
  const isDesktop = useIsDesktop();
  const colorTheme = useContext(ColorThemeContext);
  const [visible, showModal, hideModal] = useBoolean(false);

  useExecuteOnTrigger(trigger, showModal);

  const renderTitleBar = useCallback(() => {
    const exitIconProps = isDesktop
      ? null
      : {
          rightIcon: 'exit' as MBIconV2Name,
          rightIconColor: colorTheme.foregroundActive,
          onRightIconPress: hideModal,
        };

    return <AnchoredSheetTitleBar title={label} {...exitIconProps} />;
  }, [colorTheme.foregroundActive, label, hideModal, isDesktop]);

  const fixedWidth = useIsDesktop() ? FIXED_WIDTH : null;

  return (
    <>
      <TouchableOpacity onPress={showModal} style={{ maxWidth: '100%' }} disabled={isReadOnly}>
        {children}
      </TouchableOpacity>
      {visible && (
        <AnchoredSheet anchorName={anchorName} onClose={hideModal} renderTitleBar={renderTitleBar}>
          <MBView style={fixedWidth}>
            <AuditTag
              tagOptions={tagOptions}
              tags={tags}
              isMultiselect={isMultiselect}
              onChange={onChange}
              onClose={hideModal}
            />
          </MBView>
        </AnchoredSheet>
      )}
    </>
  );
}
